import {AnimationNamesExpression} from '../../../expressions/methods/animationNames';
import {ArgExpression} from '../../../expressions/methods/arg';
import {ArgcExpression} from '../../../expressions/methods/argc';
import {BboxExpression} from '../../../expressions/methods/bbox';
import {CameraNameExpression} from '../../../expressions/methods/cameraName';
import {CameraNamesExpression} from '../../../expressions/methods/cameraNames';
import {CamerasCountExpression} from '../../../expressions/methods/camerasCount';
import {CentroidExpression} from '../../../expressions/methods/centroid';
import {ChExpression} from '../../../expressions/methods/ch';
import {ChsopExpression} from '../../../expressions/methods/chsop';
import {CopyExpression} from '../../../expressions/methods/copy';
import {CopResExpression} from '../../../expressions/methods/copRes';
import {isDeviceMobileExpression} from '../../../expressions/methods/isDeviceMobile';
import {isDeviceTouchExpression} from '../../../expressions/methods/isDeviceTouch';
import {LenExpression} from '../../../expressions/methods/len';
import {JoinExpression} from '../../../expressions/methods/join';
import {JsExpression} from '../../../expressions/methods/js';
import {ObjectExpression} from '../../../expressions/methods/object';
import {ObjectsCountExpression} from '../../../expressions/methods/objectsCount';
import {ObjectNameExpression} from '../../../expressions/methods/objectName';
import {ObjectNamesExpression} from '../../../expressions/methods/objectNames';
import {OpdigitsExpression} from '../../../expressions/methods/opdigits';
import {OpnameExpression} from '../../../expressions/methods/opname';
import {PadzeroExpression} from '../../../expressions/methods/padzero';
import {PlayerModeExpression} from '../../../expressions/methods/playerMode';
import {PointExpression} from '../../../expressions/methods/point';
import {PointsCountExpression} from '../../../expressions/methods/pointsCount';
import {SolverIterationExpression} from '../../../expressions/methods/solverIteration';
import {StrCharsCountExpression} from '../../../expressions/methods/strCharsCount';
import {StrConcatExpression} from '../../../expressions/methods/strConcat';
import {StrIndexExpression} from '../../../expressions/methods/strIndex';
import {StrSubExpression} from '../../../expressions/methods/strSub';
import {WindowSizeExpression} from '../../../expressions/methods/windowSize';

import {BaseMethod} from '../../../expressions/methods/_Base';
export interface ExpressionMap extends PolyDictionary<typeof BaseMethod> {
	animationNames: typeof AnimationNamesExpression;
	arg: typeof ArgExpression;
	argc: typeof ArgcExpression;
	bbox: typeof BboxExpression;
	cameraName: typeof CameraNameExpression;
	cameraNames: typeof CameraNamesExpression;
	camerasCount: typeof CamerasCountExpression;
	centroid: typeof CentroidExpression;
	ch: typeof ChExpression;
	chsop: typeof ChsopExpression;
	copy: typeof CopyExpression;
	copRes: typeof CopResExpression;
	isDeviceMobile: typeof isDeviceMobileExpression;
	isDeviceTouch: typeof isDeviceTouchExpression;
	join: typeof JoinExpression;
	js: typeof JsExpression;
	len: typeof LenExpression;
	object: typeof ObjectExpression;
	objectsCount: typeof ObjectsCountExpression;
	objectName: typeof ObjectNameExpression;
	objectNames: typeof ObjectNamesExpression;
	opdigits: typeof OpdigitsExpression;
	opname: typeof OpnameExpression;
	padzero: typeof PadzeroExpression;
	playerMode: typeof PlayerModeExpression;
	point: typeof PointExpression;
	pointsCount: typeof PointsCountExpression;
	solverIteration: typeof SolverIterationExpression;
	strCharsCount: typeof StrCharsCountExpression;
	strConcat: typeof StrConcatExpression;
	strIndex: typeof StrIndexExpression;
	strSub: typeof StrSubExpression;
	windowSize: typeof WindowSizeExpression;
}

import {PolyEngine} from '../../../Poly';
import {PolyDictionary} from '../../../../types/GlobalTypes';
export class AllExpressionsRegister {
	static run(poly: PolyEngine) {
		poly.expressionsRegister.register(AnimationNamesExpression, 'animationNames');
		poly.expressionsRegister.register(ArgExpression, 'arg');
		poly.expressionsRegister.register(ArgcExpression, 'argc');
		poly.expressionsRegister.register(BboxExpression, 'bbox');
		poly.expressionsRegister.register(CameraNameExpression, 'cameraName');
		poly.expressionsRegister.register(CameraNamesExpression, 'cameraNames');
		poly.expressionsRegister.register(CamerasCountExpression, 'camerasCount');
		poly.expressionsRegister.register(CentroidExpression, 'centroid');
		poly.expressionsRegister.register(ChExpression, 'ch');
		poly.expressionsRegister.register(ChsopExpression, 'chsop');
		poly.expressionsRegister.register(CopyExpression, 'copy');
		poly.expressionsRegister.register(CopResExpression, 'copRes');
		poly.expressionsRegister.register(isDeviceMobileExpression, 'isDeviceMobile');
		poly.expressionsRegister.register(isDeviceTouchExpression, 'isDeviceTouch');
		poly.expressionsRegister.register(LenExpression, 'len');
		poly.expressionsRegister.register(JoinExpression, 'join');
		poly.expressionsRegister.register(JsExpression, 'js');
		poly.expressionsRegister.register(ObjectExpression, 'object');
		poly.expressionsRegister.register(ObjectsCountExpression, 'objectsCount');
		poly.expressionsRegister.register(ObjectNameExpression, 'objectName');
		poly.expressionsRegister.register(ObjectNamesExpression, 'objectNames');
		poly.expressionsRegister.register(OpdigitsExpression, 'opdigits');
		poly.expressionsRegister.register(OpnameExpression, 'opname');
		poly.expressionsRegister.register(PadzeroExpression, 'padzero');
		poly.expressionsRegister.register(PlayerModeExpression, 'playerMode');
		poly.expressionsRegister.register(PointExpression, 'point');
		poly.expressionsRegister.register(PointsCountExpression, 'pointsCount');
		poly.expressionsRegister.register(SolverIterationExpression, 'solverIteration');
		poly.expressionsRegister.register(StrCharsCountExpression, 'strCharsCount');
		poly.expressionsRegister.register(StrConcatExpression, 'strConcat');
		poly.expressionsRegister.register(StrIndexExpression, 'strIndex');
		poly.expressionsRegister.register(StrSubExpression, 'strSub');
		poly.expressionsRegister.register(WindowSizeExpression, 'windowSize');
	}
}
